import T from '../action-types'

const initialState = {
  viewId: 'default', // not used ?
  locale: 'en',
  loading: false,
  modalDisplay: false,
  modalTitle: '',
  modalViewSchema: null,
}

export default function AXGView(state=initialState, action) {
  switch (action.type) {
    case T.SET_VIEWID:
      var viewId = action.options.viewId
      // TODO: get reliable current viewId
      // if (state.current != viewId) {
      //   window.appxigon.history.push(`/${viewId}`)
      // }
      window.appxigon.history.push(`/${viewId}`)
      return {
        ...state,
        current: viewId,
      }
    case T.SET_LOADING:
      return {
        ...state,
        loading: action.options.loading,
      }
    case T.SET_MODAL_VIEW_SCHEMA:
      return {
        ...state,
        modalDisplay: true,
        modalViewSchema: action.options.schema,
      }
    case T.SET_MODAL_TITLE:
      return {
        ...state,
        modalTitle: action.title,
      }
    case T.SET_MODAL_STYLE:
      return {
        ...state,
        modalStyle: action.style,
      }
    case T.SET_LOCALE:
      return {
        ...state,
        locale: action.locale,
      }
    case T.CLOSE_MODAL:
      return {
        ...state,
        modalDisplay: false,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/axg-view.js